import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useSearchParams } from "react-router";
import { useOrderLinkFlowStorefront } from "./useOrderLinkFlowStorefront";
import {
  BasketContextActionEnum,
  useBasketContext,
} from "../../../useBasketContext.shared";
import db from "../../../../db";
import { useSellarUser } from "../../../index";

export const useOrderFlowTokenBasket = () => {
  const [searchParams] = useSearchParams();
  const orderFlowToken = searchParams.get("orderFlowToken");
  const { user } = useSellarUser();
  const isSignedInUser = Boolean(user);

  const [, dispatchBasket] = useBasketContext();

  const [, setUnAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    "unauthorisedUserPostcode",
    undefined,
  );

  const orderLinkFlowstorefrontQuery = useOrderLinkFlowStorefront(
    isSignedInUser ? null : orderFlowToken,
    { enabled: !isSignedInUser && Boolean(orderFlowToken) },
  );

  useEffect(() => {
    const basket = orderLinkFlowstorefrontQuery.data?.basket;
    if (!basket?.id) return;

    const orderWithMarker = {
      ...basket,
      _fromOrderFlowToken: true as const,
    };

    db.draftOrders
      .put({
        ...orderWithMarker,
        RetailerId: basket.RetailerId ?? 0,
        initiator: "retailer",
      })
      .then(() => {
        dispatchBasket({
          type: BasketContextActionEnum.CHANGE_ORDER,
          order: orderWithMarker,
        });
      });

    const postcode =
      orderLinkFlowstorefrontQuery.data?.storefront.unAuthorisedUserPostcode;
    if (postcode) {
      setUnAuthorisedUserPostcode(postcode);
    }
  }, [
    dispatchBasket,
    orderLinkFlowstorefrontQuery.data,
    setUnAuthorisedUserPostcode,
  ]);
};
